import ClearIcon from '@mui/icons-material/Clear';
import { Button } from '@mui/material';
import React from 'react';
import { z } from 'zod';
import { useFilterBarCtx } from '../FilterBar';
import { __useClearFilterState } from '../useFilterState';

const clearButtonComponentProps = z.object({
  displayName: z.string().optional(),
  className: z.string().optional(),
  icon: z.boolean().optional(),
  variant: z.enum(['text', 'outlined', 'contained']).optional(),
  size: z.enum(['small', 'medium', 'large']).optional(),
});

const clearButtonSearchSchema = z.object({});

type ClearButtonProps = z.infer<typeof clearButtonComponentProps>;

const ClearButton = ({
  displayName = 'Clear Filters',
  className = 'z-btn-6',
  icon = true,
  variant = 'outlined',
  size = 'medium',
}: ClearButtonProps) => {
  const { props: ctxProps } = useFilterBarCtx();

  const { hasFilters, resetAllFilters } = __useClearFilterState();

  if (!hasFilters) {
    return null;
  }

  const variantButton = `${ctxProps?.variant === 'default' ? 'z-btn-6' : 'z-btn-compact'} ${className}`.trim();

  return (
    <div style={{ position: 'relative' }}>
      <Button
        variant={variant}
        size={size}
        className={variantButton}
        onClick={resetAllFilters}
        startIcon={icon ? <ClearIcon /> : undefined}
        color="primary"
      >
        {displayName}
      </Button>
    </div>
  );
};

const ClearButtonMemo = React.memo(ClearButton);

export const FilterConfig_ClearButton = {
  clearBtn: {
    searchSchema: clearButtonSearchSchema,
    component: ClearButtonMemo,
    componentProps: clearButtonComponentProps,
  },
} as const;
